let url = `${process.env.REACT_APP_DEVELOPMENT_URL}`;

const createCheckoutSession = async (data) => {
  const endpoint = `${url}create-checkout-session/`;
  const headers = new Headers();
  const formData = new FormData();
  formData.append('price', data.price);
  headers.append("Cookie", "csrftoken=Rvl7V0RuAC3rxnUOBnppzg5LAHBK4kw6CXQv3qOrKKrjV6F6oSUKNBGp7eRowLod");

  return await fetch(endpoint, {
    method: 'POST',
    body: formData,
    headers,
    redirect: 'follow'
  })
  .then(response => {
    return response.text();
  });
}

const createPortalSession = async (data) => {
  const endpoint = `${url}create-portal-session/`;
  const formData = new FormData();
  formData.append('customer', data.customer);

  return await fetch(endpoint, {
    method: 'POST',
    body: formData,
    redirect: 'follow'
  })
  .then(response => {
    return response.text();
  });
}

export const stripeService = {
  createCheckoutSession,
  createPortalSession
}